import React, {Component} from 'react';
import {Modal, Button, Row}  from 'react-bootstrap'
import SecondServer from '../database/SecondServer'
import FormFactory from '../FormData/FormFactory';
import {Header, InputCommon, inputBorder} from '../Modal/CommonParts.js'
import {promisePerms} from '../Report/DataHelpers'
import GrantRequest from '../Grants/RequestDialog'
import { grantAccessCode } from '../database/apiv2SiteAccessor';

import '../Report/report-header.css'
import '../Report/Controls/massedit.css'
import '../commoninputs.css'
import './siteadd.css'

export default class SiteAdd extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      errMsg: null,
      rerender: 0,
      grantNeeded: false,
    }
    this.siteAttribs = ["access_code", "note"];
    this.validations = {"access_code": true};
    this.handleClose = this.handleClose.bind(this);
    this.validate = this.validate.bind(this);
    this.validateAndMoveOn = this.validateAndMoveOn.bind(this);
    this.ff = new FormFactory()
  }

  componentDidMount() {
    this.initState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.opened !== this.props?.opened)
      this.initState();
  }

  initState () {
    this.ff.init()
    this.setState ({errMsg: null, grantNeeded: false})
    this.validations = {"name": true, "access_code": true};
  }
  
  async permissions() {
    let ss = new SecondServer(this.props);
    const field = this.ff.findChange('access_code');
    const perms = await promisePerms(ss, field.value)
    return perms
  }

  async saveChanges() {
    const url = "/tehama/site-list-server"
    const ss = new SecondServer(this.props);
    let saveObj = this.ff.jsonifyInputs(this.siteAttribs);
    const resp = await ss.apiInsertData (url, saveObj);
    let msg = ss.getErrorMsg();
    if (msg) {
      //console.log (msg, resp?.response, resp?.response?.data)
      const jsonBug = resp?.response?.data
      if (typeof jsonBug === 'string')  {   // true Mar 2025
        const disp = jsonBug.indexOf('"message":') 
        if (disp > -1) {
          const end = jsonBug.indexOf('\n')
          msg = jsonBug.substring(disp+12, end)
        }
      }
    }
    this.setState ( {errMsg: msg } );
    return msg
  }

  async handleClose() {
    this.props.hide();
    this.initState();
  }

  handleChange = event => {
    this.ff.handleChange(event);
    this.setState ({rerender: this.state.rerender+1})
  }
  
  validate () {
    let fieldName = 'access_code'
    this.validations[fieldName] = true;
    let field = this.ff.findChange(fieldName);
    if (!field || !field?.value) {
      this.validations[fieldName] = false;
      return "Access code cannot be blank"
    }
    field.value = field?.value.replace(/\s/g,'')
    const re = /[0-9]{11}/g;
    if(!re.test(field?.value)) {
      this.validations[fieldName] = false;
      return "Access code should be 11 digits";
    }
    if (this.isSiteCached(field.value))
      return "You already have access to this site"

    return null;
  }
  
  isSiteCached(siteid) {
    const cache = this.props.siteMap()
    if (cache.get(siteid))
      return true;
    return (this.props?.grants?.some(grant => siteid === grantAccessCode(grant)))
  }

  async moveOn () {
    const err = await this.saveChanges();
    if (!err) {
      this.handleClose();

      if (this.props.onChange)
        this.props.onChange(this.state);
      
      window.location.reload(true);  
    } 
  }

  async validateAndMoveOn() {
    const msg = this.validate()
    if (msg) {
      this.setState({errMsg: msg})
      return;
    }
    /*const perms = await this.permissions();
    if (!permitted(perms?.data?.data)) {
      this.setState ({grantNeeded:true})
      return;
    } */
    this.moveOn ()
  }
  modalInput (id, prompt, valid=true, inputSize=35) {
    const bcolor = inputBorder(valid);
    const prev_item = this.ff.findChange(id)
    const toDisplay = prev_item ? prev_item.value : ""
    return (<InputCommon id={id} prompt={prompt} element=
        {<input className={"compact-item "+bcolor} type="text" value={toDisplay} id={id} size={inputSize}
          onChange={this.handleChange}/>}
    />)
  }

  grantModal (state) {
    this.setState({grantNeeded: state})
    if (false === state)
      this.handleClose();
  }

  renderTab1() {
    return(
      <Modal.Body className='body-indent'>
        <Row className='mt-5 modal-top-row '>
          {this.modalInput('access_code', 'Access Code', this.validations["access_code"])}
        </Row>
      </Modal.Body>
    )
  }
/* snip from previous function
          {this.modalInput('name', 'Site Name', this.validations["name"])}
          {this.spacerCol()}

        <Row className='mt-4'>
          {this.modalInput('note', 'Note', true, 90)}
        </Row>
*/

  render() {
    const field = this.ff.findChange('access_code');
    const inject = field?.value
    if (this.state.grantNeeded) 
      return (<GrantRequest {...this.props} AC={inject} show={this.state.grantNeeded} hide={()=>this.grantModal(false)} /> );
    return(
      <Modal show={this.props.show} onHide={this.handleClose} size="lg">
        <Header title={"Add Site"} />
        {this.renderTab1()}
        <Modal.Footer>
          <div className="modal-error">{this.state.errMsg}</div>
          <Button className="custom-std-btn" onClick={()=>this.handleClose()}>Cancel</Button>
          <Button className="custom-std-btn" onClick={()=>this.validateAndMoveOn()}>Save</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
